import type { ReactElement } from "react";
import { useAuth } from "@/core/auth/auth-provider";
import { Button } from "@/shared/components/ui";

// Gradient-header auth-control treatment (Figma navigation sheets / CLM wiki design source):
// filled white with brand-blue text so it reads on the gradient's light right end (Tracker
// continuity, Luis 2026-10-30). Shared by Sign out and the public header's Sign in. The white ring
// over a brand-blue offset gap keeps focus visible on the light end.
export const GRADIENT_AUTH_BUTTON_CLASSES =
  "border-white bg-white text-clm-primary-blue hover:border-white hover:bg-white/90 hover:text-clm-primary-blue focus-visible:ring-white focus-visible:ring-offset-clm-primary-blue";

export function UserMenu(): ReactElement {
  const auth = useAuth();
  const user = auth.session?.user;
  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
  const displayName = user?.displayName ?? (fullName || user?.email) ?? "Unauthenticated";

  return (
    <div className="flex items-center gap-3 text-sm text-white" aria-label="User profile controls">
      <div className="min-w-0 max-w-48 rounded-[3px] bg-black/20 px-2 py-1 text-right">
        <p className="truncate font-semibold" title={displayName}>
          {displayName}
        </p>
        <p className="hidden text-xs text-white sm:block">Session: {auth.status}</p>
      </div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={GRADIENT_AUTH_BUTTON_CLASSES}
        onClick={() => void auth.logout()}
      >
        Sign out
      </Button>
    </div>
  );
}
